import { Box, Flex, Grid, Text } from 'theme-ui'
import s from './bus-grid.module.scss'

import Marquee from 'react-fast-marquee'

import { default as bus1 } from '~/public/images/buses/bus1.png'

import { default as bus2 } from '~/public/images/buses/bus2.png'

import { default as bus3 } from '~/public/images/buses/bus3.png'

import { default as bus4 } from '~/public/images/buses/bus4.png'

import { default as bus5 } from '~/public/images/buses/bus5.png'

import { default as bus6 } from '~/public/images/buses/bus6.png'

import { default as bus7 } from '~/public/images/buses/bus7.png'

import { default as bus8 } from '~/public/images/buses/bus8.png'

import { default as bus9 } from '~/public/images/buses/bus9.png'

import { default as bus10 } from '~/public/images/buses/bus10.png'

import { default as bus11 } from '~/public/images/buses/bus11.png'

import { default as bus12 } from '~/public/images/buses/bus12.png'

import { default as bus13 } from '~/public/images/buses/bus13.png'

import { default as bus14 } from '~/public/images/buses/bus14.png'

import { default as bus15 } from '~/public/images/buses/bus15.png'

import { default as bus16 } from '~/public/images/buses/bus16.png'
import { Section } from '../common/section'
import { TitleAndSubtitle } from '../primitives/texts'

// todo: read from contract once deployed!
const saleOn = false
const isLoading = false
const currentSupply = 123
const totalSupply = 4545

export default function BusGrid() {
  return (
    <Section>
      <TitleAndSubtitle
        className={s.titleAndSubtitle}
        title={{
          children: <div>Tokenized Transit Union</div>,
          as: 'h2'
        }}
        subtitle={{
          children: <>Channel your inner bus driver</>,
          className: s.subtitle
        }}
      />
      <Box sx={{ position: 'relative' }} m={4}>
        <Marquee speed={15} gradient={false}>
          {[...Array(6)].map((_, i) => (
            <CharactersTopGrid key={i} />
          ))}
        </Marquee>
        <Marquee speed={15} direction="right" gradient={false}>
          {[...Array(6)].map((_, i) => (
            <BusesBottomGrid key={i} />
          ))}
        </Marquee>
        <Marquee gradient={false}>
          {[...Array(12)].map((_, i) => (
            <Ticker key={i} />
          ))}
        </Marquee>
      </Box>
    </Section>
  )
}

function CharactersTopGrid() {
  return (
    <Grid gap={3} columns={8} paddingLeft={3} paddingBottom={3}>
      <Bus src={bus1.src} />
      <Bus src={bus2.src} />
      <Bus src={bus3.src} />
      <Bus src={bus4.src} />
      <Bus src={bus5.src} />
      <Bus src={bus6.src} />
      <Bus src={bus7.src} />
      <Bus src={bus8.src} />
    </Grid>
  )
}

function BusesBottomGrid() {
  return (
    <Grid gap={3} columns={8} paddingLeft={3} paddingBottom={3}>
      <Bus src={bus9.src} />
      <Bus src={bus10.src} />
      <Bus src={bus11.src} />
      <Bus src={bus12.src} />
      <Bus src={bus13.src} />
      <Bus src={bus14.src} />
      <Bus src={bus15.src} />
      <Bus src={bus16.src} />
    </Grid>
  )
}

function Bus({ src }: { src: string }) {
  return (
    <Box
      sx={{
        borderRadius: 12,
        overflow: 'hidden',
        img: { display: 'block' },
        width: [228, 'auto', 'auto', 'auto']
      }}
    >
      {/* <Image alt="Bus" src={src} /> */}
      <img alt="Bus" src={src} height="auto" width="300px" />
    </Box>
  )
}

function Ticker() {
  return (
    <Flex
      sx={{
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Text
        sx={{
          fontSize: 1,
          fontWeight: '500',
          fontFamily: 'FastTrack',
          letterSpacing: 1.1,
          textTransform: 'uppercase'
          // color: 'white',
        }}
        color="discord"
      >
        {!isLoading && saleOn
          ? `${currentSupply}/${totalSupply} minted`
          : 'minting soon'}
      </Text>
      <Box p={2}>
        <Dot />
      </Box>
    </Flex>
  )
}

function Dot() {
  return (
    <Box
      sx={{
        width: '4px',
        height: '4px',
        borderRadius: '2px',
        bg: 'secondary'
      }}
    ></Box>
  )
}
